import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { CommunicationUserType, UserRole } from 'src/app/models/enums';
import { StorageService, UtilsService } from 'src/app/services';
import { LiteralService } from 'src/app/services/literal/literal.service';
import { SuggestionService } from 'src/app/services/suggestion/suggestion.service';
import { environment } from 'src/environments/environment';
import { images } from 'src/images';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: false
})
export class SidebarComponent implements OnInit, OnDestroy {
  @Output() setRouteName = new EventEmitter<string>(true);
  @Input() routeName = '';

  public images = images;
  public hidden = true;
  public hiddenAdmin = true;
  public role = UserRole.ADMIN;
  public pendingSuggestionsCount = 0;
  public usersListType = CommunicationUserType.USERS;
  public suggestionsListType = CommunicationUserType.USERS;

  public showSidebarTimeout: any = null;

  public page = '';

  private subscriptions: Subscription[] = [];

  constructor(
    public literalService: LiteralService,
    public storageService: StorageService,
    public utilsService: UtilsService,
    private suggestionService: SuggestionService,
  ) {}

  async ngOnInit() {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    this.subscriptions.push(
      this.suggestionService.pendingCount$.subscribe(count => {
        this.pendingSuggestionsCount = count;
      })
    );

    const sidebarSubmenu = document.getElementById('sidebar-submenu') || null;
    const sidebarSubmenuAdmin =
      document.getElementById('sidebar-submenu-admin') || null;

    this.role = await this.storageService.getRole();
    await this.refreshListTypes();
    this.subscriptions.push(
      this.storageService.onRouteNameChange$.subscribe(() => this.refreshListTypes())
    );

    // document.getElementById("adminsSectionList")?.addEventListener("mouseover", () => {
    //   this.hidden = false
    //   sidebarSubmenu && (sidebarSubmenu.style.setProperty('display', 'block', 'important'))
    // });
    const elements = Array.from(
      document.getElementsByClassName('sidebar-item-list'),
    );
    elements.forEach((element: Element) => {
      element.addEventListener('mouseover', () => {
        if (!this.showSidebarTimeout && !this.utilsService.isTouchDevice()) {
          this.showSidebarTimeout = setTimeout(() => {
            if (this.hidden && this.showSidebarTimeout) {
              this.hidden = false;
              sidebarSubmenu && sidebarSubmenu.style.setProperty('display', 'block', 'important');
              this.showSidebarTimeout = null;
            }
          }, 500);
        }
      });
      element.addEventListener('mouseleave', () => {
        this.showSidebarTimeout = null;
      });
    });

    // document.getElementById("adminsSectionList")?.addEventListener("mouseleave", () => {
    //   if (!document.getElementById("sidebar-submenu")?.matches(':hover')) {
    //     this.hidden = true
    //     setTimeout(() => {
    //       sidebarSubmenu && (sidebarSubmenu.style.setProperty('display', 'none', 'important'))
    //     }, 200)
    //   }
    // });

    document.addEventListener('mouseleave', () => {
      if (!this.hidden) {
        this.hidden = true;
        sidebarSubmenu && sidebarSubmenu.style.setProperty('display', 'none', 'important');
        this.showSidebarTimeout = null;
      }
    })

    document
      .getElementById('sidebar-submenu')
      ?.addEventListener('mouseover', () => {
        this.hidden = false;
        document
          .getElementById('adminsSectionList')
          ?.classList.add('submenu-hovered');
        sidebarSubmenu &&
          sidebarSubmenu.style.setProperty('display', 'block', 'important');
      });

    document
      .getElementById('sidebar-submenu')
      ?.addEventListener('mouseleave', () => {
        if (
          !document.getElementById('adminsSectionList')?.matches(':hover') &&
          !document.getElementById('sidebar-submenu-admin')?.matches(':hover')
        ) {
          this.hidden = true;
          setTimeout(() => {
            sidebarSubmenu &&
              sidebarSubmenu.style.setProperty('display', 'none', 'important');
          }, 200);
          this.showSidebarTimeout = null;
        }
        document
          .getElementById('adminsSectionList')
          ?.classList.remove('submenu-hovered');
      });

    document
      .getElementById('adminsSubmenuSectionList')
      ?.addEventListener('mouseover', () => {
        this.hidden = false;
        this.hiddenAdmin = false;
        sidebarSubmenuAdmin &&
          sidebarSubmenuAdmin.style.setProperty(
            'display',
            'block',
            'important',
          );
      });

    document
      .getElementById('adminsSubmenuSectionList')
      ?.addEventListener('mouseleave', () => {
        // this.hidden = true
        this.hiddenAdmin = true;
        sidebarSubmenuAdmin &&
          sidebarSubmenuAdmin.style.setProperty('display', 'none', 'important');
      });

    document
      .getElementById('sidebar-submenu-admin')
      ?.addEventListener('mouseover', () => {
        this.hidden = false;
        this.hiddenAdmin = false;
        sidebarSubmenuAdmin &&
          sidebarSubmenuAdmin.style.setProperty(
            'display',
            'block',
            'important',
          );
        document
          .getElementById('adminsSectionList')
          ?.classList.add('submenu-hovered');
        document
          .getElementById('adminsSubmenuSectionList')
          ?.classList.add('submenu-admin-hovered');
      });

    document
      .getElementById('sidebar-submenu-admin')
      ?.addEventListener('mouseleave', () => {
        this.hidden = true;
        this.hiddenAdmin = true;
        sidebarSubmenuAdmin &&
          sidebarSubmenuAdmin.style.setProperty('display', 'none', 'important');
        document
          .getElementById('adminsSectionList')
          ?.classList.remove('submenu-hovered');
        document
          .getElementById('adminsSubmenuSectionList')
          ?.classList.remove('submenu-admin-hovered');
      });
  }

  public setRouteNameSelected(routeName: string) {
    this.setRouteName.emit(routeName);
  }

  // Admins and superadmins land on the list they last visited; other roles only have one list
  private async refreshListTypes() {
    if (this.role === UserRole.SUPERADMIN || this.role === UserRole.ADMIN) {
      this.usersListType = (await this.storageService.getUsersLastListType()) ?? CommunicationUserType.USERS;
      this.suggestionsListType = (await this.storageService.getSuggestionsLastListType()) ?? CommunicationUserType.USERS;
      return;
    }
    const listType = this.role === UserRole.DRIVER_MANAGER ? CommunicationUserType.DRIVERS : CommunicationUserType.USERS;
    this.usersListType = listType;
    this.suggestionsListType = listType;
  }

  getDashboardUrl() {
    if (environment.location === 'tst') {
      return 'https://dashboard-tst.nemi.mobi/';
    }  else if (environment.location === 'demo') {
      return 'https://dashboard-dmo.nemi.mobi/';
    } else if (environment.location === 'sta') {
      return 'https://dashboard-sta.nemi.mobi/';
    } else if (environment.location === 'prod') {
      return 'https://dashboard.nemi.mobi/';
    }
    return 'https://dashboard.nemi.mobi/';
  };

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
